import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function CTABand({ onContact }) {
  return (
    <section data-testid="cta-section" className="bg-navy py-28 lg:py-36">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] font-semibold text-ivory/50 mb-6">Let&apos;s Talk</p>
          <h2 className="font-display text-ivory text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight">
            Ready to Build <em className="italic font-medium">Your Product?</em>
          </h2>
          <p className="mt-6 text-ivory/60 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
            Tell us about your idea — we&apos;ll tell you exactly how to bring it to life.
          </p>
          <button
            data-testid="cta-contact-btn"
            onClick={onContact}
            className="group btn-shine mt-10 inline-flex items-center gap-3 rounded-full bg-ivory text-navy px-10 py-4 text-sm font-bold tracking-wide transition-transform duration-300 hover:-translate-y-0.5"
          >
            Contact Us
            <ArrowRight size={16} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
